import React, { HTMLAttributes, ReactElement, ReactNode, useEffect, useState } from 'react'
import { IWithDropdownProps, withDropdown } from '../../../lib/hoc/WithDropdown'
import { Square } from '../../utility/square/Square'
import { BpButton } from '../../buttons/bp-button/BpButton'

export interface ICardDropParams extends IWithDropdownProps {
  title?: string
  trigger?: ReactElement
  offsetTop?: number
  position?: 'right' | 'left'
  children?: ReactNode | undefined
  className?: string
  opened?: boolean
}

const Drop = ({
  title,
  trigger,
  position = 'right',
  children,
  className,
  opened,
  open,
  onToggle,
}: ICardDropParams & HTMLAttributes<HTMLElement>) => {
  const [isHidden, setIsHidden] = useState(!open)

  useEffect(() => {
    open ? setIsHidden(false) : setTimeout(() => setIsHidden(true), 150)
  })

  useEffect(() => {
    opened && onToggle && onToggle()
  }, [opened])

  return (
    <div className='relative table w-full select-none'>
      {trigger ? (
        <button onClick={onToggle}>{trigger}</button>
      ) : (
        <BpButton
          active={open}
          contentClassName={'!text-white !font-normal'}
          size={'sm'}
          theme={'transparent'}
          type={'button'}
          onClick={onToggle}
        >
          {title}
        </BpButton>
      )}
      <div
        className={`absolute top-[35px] transition-opacity duration-150 ${position === 'right' ? 'right-0' : 'left-0'} ${open ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'} ${isHidden && 'invisible'} z-50 ${className} `}
      >
        <Square>{children}</Square>
      </div>
    </div>
  )
}

export const CardDrop = withDropdown(Drop)
